// extracted by mini-css-extract-plugin
module.exports = {"bottomFields":"consent_bottomFields__1tnr2","vendorsDays":"consent_vendorsDays__22Hd-","warningAlert":"consent_warningAlert__2IEc0"};